import { fromJS } from 'immutable';
import * as actions from './actionTypes';
import { getErrorCode, getErrorMessage } from '../../containers/Error';

const initialState = fromJS({
  loading: false,
  data: null,
  error: { error: false, code: null, message: null, type: null, state: 'policyDetails' },
});

const policyDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_POLICY_DETAILS:
      return state
        .setIn(['loading'], false)
        .setIn(['data'], action.payload.policyDetails.policies);

    case actions.SET_POLICY_DETAILS_ERROR:
      return state
        .setIn(['loading'], false)
        .setIn(['error', 'error'], true)
        .setIn(['error', 'code'], getErrorCode(action.payload.error))
        .setIn(['error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['error', 'type'], action.type);

    case actions.CLEAR_POLICY_DETAILS:
      return state
        .setIn(['data'], null);

    case actions.CLEAR_POLICY_DETAILS_ERROR:
      return state
        .setIn(['error', 'error'], false);

    case actions.GET_POLICY_DETAILS:
      return state
        .setIn(['loading'], true);

    default:
      return state;
  }
};

export default policyDetailsReducer;
